import { AlertController } from 'ionic-angular';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomAlert{

	private alertCtrl : AlertController;

	constructor(alertCtrl : AlertController){
		this.alertCtrl = alertCtrl;
	}

	showPromptAlert(title, message, callback){
		let alert = this.alertCtrl.create({
	      title : title,
	      message : message,
	      buttons:[{
	        text : 'No',
	        role : 'cancel',
	        handler : ()=>{
				callback(false);
	        }
	      },
	      {
	        text : 'Si',
	        role : 'confirm',
	        handler : ()=>{
				callback(true);
	        }
	      }
	      ]
	    });
	    alert.present();
	}
}


// WEBPACK FOOTER //
// ./src/util/CustomAlert.ts